import { Text as Paragraph } from '@/components/Typography';
export const DescElement = ({ text }: { text: string; tag?: string }) => {
  return (
    <Paragraph data-test="text-description" tag="p" type="lg" className="intro-text">
      {text}
    </Paragraph>
  );
};
